import { API_BASE } from '../config';

export const fetchGameState = async (playerId: string) => {
  try {
    const response = await fetch(`${API_BASE}/gamestate/${playerId}`);
    
    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching game state:', error);
    throw error;
  }
};

// ...other API calls using API_BASE...
